import * as React from 'react';

const SvgResultsEmpty = (props) => (
  <svg
    width={200}
    height={200}
    viewBox="0 0 200 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M97.828 154.596C132.291 154.596 160.231 126.656 160.231 92.07C160.231 57.4836 132.168 29.5437 97.828 29.5437C63.3647 29.5437 35.4248 57.4836 35.4248 92.07C35.4248 126.656 63.3647 154.596 97.828 154.596Z"
      fill="#F4F4F4"
    />
    <path
      d="M156.169 51.0831C158.957 51.0831 161.215 48.8236 161.215 46.0366C161.215 43.2495 158.957 40.9902 156.169 40.9902C153.382 40.9902 151.123 43.2495 151.123 46.0366C151.123 48.8236 153.382 51.0831 156.169 51.0831Z"
      fill="#EAEEF9"
    />
    <path
      d="M163.554 31.39C165.458 31.39 167 29.847 167 27.9436C167 26.0403 165.458 24.4973 163.554 24.4973C161.651 24.4973 160.107 26.0403 160.107 27.9436C160.107 29.847 161.651 31.39 163.554 31.39Z"
      fill="#EAEEF9"
    />
    <path
      d="M38.7481 50.96C40.6514 50.96 42.1944 49.4171 42.1944 47.5137C42.1944 45.6104 40.6514 44.0674 38.7481 44.0674C36.8447 44.0674 35.3018 45.6104 35.3018 47.5137C35.3018 49.4171 36.8447 50.96 38.7481 50.96Z"
      fill="#EAEEF9"
    />
    <path
      d="M17.7006 117.425C21.2354 117.425 24.101 114.56 24.101 111.025C24.101 107.49 21.2354 104.625 17.7006 104.625C14.1658 104.625 11.3003 107.49 11.3003 111.025C11.3003 114.56 14.1658 117.425 17.7006 117.425Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_30614_9202)">
      <path
        d="M140.291 60.8069L141.276 140.073C141.276 142.781 139.06 144.873 136.352 144.873H59.0566C56.3488 144.873 54.1333 142.658 54.1333 140.073V38.1596C54.1333 35.4518 56.3488 33.3594 59.0566 33.3594H115.06L140.291 60.8069Z"
        fill="url(#paint0_linear_30614_9202)"
      />
    </g>
    <path
      d="M91.7966 128.995H88.9657C88.3502 128.995 87.8579 128.38 87.8579 127.641C87.8579 126.903 88.3502 126.287 88.9657 126.287H91.7966C92.412 126.287 92.9043 126.903 92.9043 127.641C92.9043 128.503 92.412 128.995 91.7966 128.995Z"
      fill="#CED7E2"
    />
    <path
      d="M83.181 128.995H66.6878C66.0724 128.995 65.5801 128.38 65.5801 127.641C65.5801 126.903 66.0724 126.287 66.6878 126.287H83.181C83.7964 126.287 84.2887 126.903 84.2887 127.641C84.2887 128.503 83.7964 128.995 83.181 128.995Z"
      fill="#D5DDEA"
    />
    <path
      d="M104.228 49.9756H67.1802C66.3186 49.9756 65.5801 49.2371 65.5801 48.3755C65.5801 47.5139 66.3186 46.7754 67.1802 46.7754H104.228C105.09 46.7754 105.828 47.5139 105.828 48.3755C105.828 49.2371 105.09 49.9756 104.228 49.9756Z"
      fill="#D5DDEA"
    />
    <path
      d="M81.4578 58.8376H67.1802C66.3186 58.8376 65.5801 58.0991 65.5801 57.2375C65.5801 56.376 66.3186 55.6375 67.1802 55.6375H81.3347C82.1963 55.6375 82.9348 56.376 82.9348 57.2375C82.9348 58.0991 82.1963 58.8376 81.4578 58.8376Z"
      fill="#D5DDEA"
    />
    <path
      d="M115.059 33.3591V55.2679C115.059 58.345 117.767 60.8067 120.844 60.8067H140.291"
      fill="#D5DDEA"
    />
    <path
      d="M146.199 146.719C144.968 146.719 143.738 146.227 142.753 145.119L122.199 124.564L121.46 125.056C114.814 129.98 107.059 132.564 99.182 132.564C89.7045 132.564 80.2271 128.749 73.2114 122.102C65.8264 115.086 61.7646 105.609 61.7646 95.2701C61.7646 74.7152 78.504 57.9758 99.0589 57.9758C113.09 57.9758 125.399 65.3608 132.045 77.9153C138.568 90.3467 137.707 104.871 129.707 116.563L129.214 117.302L149.892 137.98C151.984 140.072 151.492 142.165 151.123 143.273C150.138 145.242 148.169 146.719 146.199 146.719ZM99.0589 68.1917C84.0427 68.1917 71.9806 80.377 71.9806 95.2701C71.9806 112.256 85.889 122.471 99.4281 122.471C107.675 122.471 115.183 118.779 120.475 112.132C126.999 104.009 128.107 93.0546 123.552 83.5771C118.875 74.0997 109.521 68.1917 99.0589 68.1917Z"
      fill="url(#paint1_linear_30614_9202)"
    />
    <defs>
      <filter
        id="filter0_d_30614_9202"
        x={27.055}
        y={19.8202}
        width={141.299}
        height={165.671}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={13.5392} />
        <feGaussianBlur stdDeviation={13.5392} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30614_9202"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30614_9202"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30614_9202"
        x1={97.6765}
        y1={30.78}
        x2={97.6765}
        y2={146.074}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_30614_9202"
        x1={106.609}
        y1={57.9758}
        x2={106.609}
        y2={146.719}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#507BE1" />
        <stop offset={1} stopColor="#9013FE" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgResultsEmpty;
